import React from 'react'
import {
  CFSelect,
  CFText,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { isEmpty } from 'lodash'
import moment from 'moment'
import { dispatch } from 'store'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column justifyStart w="100%" pb="80px">
          <CFView h6 helvetica color="#666666" pb="30px">
            business hours
          </CFView>
          <CFView h6 helvetica color="#666666" pb="30px">
            mon - sun
          </CFView>
          <CFView h6 helvetica color="#666666">
            lunch
          </CFView>
          <CFView h6 helvetica color="#666666">
            11:30 am - 3:00 pm
          </CFView>
          <CFView h6 helvetica color="#666666" pb="30px">
            last order 2:40 pm
          </CFView>

          <CFView h6 helvetica color="#666666">
            dinner
          </CFView>
          <CFView h6 helvetica color="#666666">
            4:30 pm - 9:00 pm
          </CFView>
          <CFView h6 helvetica color="#666666">
            last order 8:40 pm
          </CFView>
        </CFView>
        {/* <CFView maxWidth="250px">
          <CFSelect selector={dispatch.restaurant.getHours}>
            {hours =>
              [1, 2, 3, 4, 5, 6, 0].map(day => (
                <CFView key={day} column>
                  <CFView row w="100%" mb="10px">
                    <CFView w="80px">
                      <CFView h5 black bold>{`${moment()
                        .weekday(day)
                        .format('ddd')}`}</CFView>
                    </CFView>
                    <CFView h5 black bold w="100%" row justifyEnd textRight>
                      {isEmpty(hours)
                        ? ''
                        : hours[day].open && hours[day].close
                          ? `${moment(hours[day].open).format('LT')} ${
                              hours[day].breakStart && hours[day].breakEnd
                                ? ` - ${moment(hours[day].breakStart).format(
                                    'LT'
                                  )} ${moment(hours[day].breakEnd).format(
                                    'LT'
                                  )} -`
                                : '-'
                            } ${moment(hours[day].close).format('LT')}`
                          : 'Closed'}
                    </CFView>
                  </CFView>
                </CFView>
              ))
            }
          </CFSelect>
        </CFView> */}
      </MobileScreen>
      <DefaultScreen>
        <CFView h6 helvetica color="#666666" pb="30px">
          business hours
        </CFView>
        {/* <CFView minWidth="300px">
          <CFSelect selector={dispatch.restaurant.getHours}>
            {hours =>
              [1, 2, 3, 4, 5, 6, 0].map(day => (
                <CFView key={day}>
                  <CFView row w="100%" mb="10px">
                    <CFView w="80px">
                      <CFView h5 black bold>{`${moment()
                        .weekday(day)
                        .format('ddd')}`}</CFView>
                    </CFView>
                    <CFView h5 black bold>
                      {isEmpty(hours)
                        ? ''
                        : hours[day].open && hours[day].close
                          ? `${moment(hours[day].open).format('LT')} ${
                              hours[day].breakStart && hours[day].breakEnd
                                ? ` - ${moment(hours[day].breakStart).format(
                                    'LT'
                                  )}, ${moment(hours[day].breakEnd).format(
                                    'LT'
                                  )} -`
                                : '-'
                            } ${moment(hours[day].close).format('LT')}`
                          : 'Closed'}
                    </CFView>
                  </CFView>
                </CFView>
              ))
            }
          </CFSelect>
        </CFView> */}
        <CFView h6 helvetica color="#666666" pb="30px">
          mon - sun
        </CFView>
        <CFView h6 helvetica color="#666666">
          lunch
        </CFView>
        <CFView h6 helvetica color="#666666">
          11:30 am - 3:00 pm
        </CFView>
        <CFView h6 helvetica color="#666666" pb="30px">
          last order 2:40 pm
        </CFView>

        <CFView h6 helvetica color="#666666">
          dinner
        </CFView>
        <CFView h6 helvetica color="#666666">
          4:30 pm - 9:00 pm
        </CFView>
        <CFView h6 helvetica color="#666666">
          last order 8:40 pm
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
